module.exports = __webpack_public_path__ + "img/shield.83c68a5c.svg";